import React from "react";
import { Props } from "./types";

const ExpenseIcon = ({ className }: Props) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17.999 18"
  >
    <path
      d="M-2065.622-1681.689a1.676,1.676,0,0,1-1.193-.494l-7.448-7.449a1.7,1.7,0,0,1-.495-1.193V-1698a1.689,1.689,0,0,1,1.688-1.687h7.177a1.7,1.7,0,0,1,1.193.494l7.448,7.449a1.676,1.676,0,0,1,.493,1.193,1.676,1.676,0,0,1-.493,1.193l-7.176,7.177A1.678,1.678,0,0,1-2065.622-1681.689Zm-4.636-5.876v.751c0,.62,1.514,1.125,3.375,1.125s3.376-.5,3.376-1.125v-.751a6.343,6.343,0,0,1-3.376.751A6.342,6.342,0,0,1-2070.258-1687.565Zm0-1.844h0v.907c0,.62,1.514,1.125,3.375,1.125s3.376-.5,3.376-1.125v-.907a5.657,5.657,0,0,1-3.376.907,5.657,5.657,0,0,1-3.375-.907Zm3.375-2.468c-1.861,0-3.375.631-3.375,1.406s1.514,1.407,3.375,1.407,3.376-.631,3.376-1.407S-2065.022-1691.877-2066.883-1691.877Zm5.626.937a4.251,4.251,0,0,1-1.687.606v1.119c1.041-.2,1.688-.574,1.688-.974Zm0-1.687a5.63,5.63,0,0,1-2.825.734,1.97,1.97,0,0,1,1.055,1.005c1.092-.2,1.77-.575,1.77-.989Zm-3.375-2.063c-1.861,0-3.376.5-3.376,1.125s1.514,1.125,3.376,1.125,3.375-.5,3.375-1.125S-2062.771-1694.69-2064.633-1694.69Zm-6.188-2.749a1.69,1.69,0,0,0-1.687,1.688,1.69,1.69,0,0,0,1.688,1.688,1.69,1.69,0,0,0,1.688-1.687A1.69,1.69,0,0,0-2070.821-1697.439Z"
      transform="translate(2074.758 1699.689)"
    />
  </svg>
);

export { ExpenseIcon };
